import { Route } from '@angular/router';
import { PaymentComponent } from './payment.component';

export const PaymentRoutes: Route[] = [
  {
    path: 'payment',
    component: PaymentComponent
  }
];
